import { CDNImage } from '../../common/interfaces/cdnImage';
import { TaskListProgressBarStyleConfig } from '../../taskList/interfaces';

interface ButtonStyle {
  textColor: string;
  fillColor: string;
  outlineColor: string;
  text?: string;
}

export interface TimeLineStyle {
  lineColor: string | null;
  iconContainerColor: string | null;
  iconColor: string | null;
}

export interface TemplateUtilityLink {
  label: string;
  url: string;
}
export interface UtilityBarStyle {
  backgroundColor: string;
  textColor: string;
  logo: CDNImage | null;
}
export interface FooterStyle {
  backgroundColor: string;
  textColor: string;
  helpButton: ButtonStyle;
}
export interface PageStyle {
  backgroundColor: string;
  containerColor: string;
  backgroundImage: CDNImage | null;
  fontType: string;
  fontColor: string;
  buttonStyle1: ButtonStyle;
  buttonStyle2: ButtonStyle;
  flexibleBanner: boolean;
  primaryColor?: string;
  secondaryColor?: string;
  terniaryColor?: string;
  quaternaryColor?: string;
  taskListTitleColor?: string;
  taskListSectionColor?: string;
  timeline: TimeLineStyle;
  progressBar?: TaskListProgressBarStyleConfig;
}

export interface TemplateSettings {
  requiresLogin: boolean;
  utilityBar: UtilityBarStyle;
  links: TemplateUtilityLink[];
  footer: FooterStyle;
  page: PageStyle;
  mfsEnabled?: boolean;
}
export interface Template {
  layoutCode: TemplateLayout.TEMPLATE_LAYOUT_01 | TemplateLayout.TEMPLATE_LAYOUT_02 | null;
  id: string;
  type: TemplateType.EXPERIENCE_LITE | TemplateType.BASIC_EXPERIENCE_LITE;
  status: string;
  firstWorkflowItemId: string;
  companyId: number;
  settings: TemplateSettings;
}

export enum TemplateLayout {
  TEMPLATE_LAYOUT_01 = 'TEMPLATE_LAYOUT_01',
  TEMPLATE_LAYOUT_02 = 'TEMPLATE_LAYOUT_02',
}

export enum TemplateType {
  EXPERIENCE_LITE = 'experience_lite',
  BASIC_EXPERIENCE_LITE = 'basic_experience_lite',
}
